window.VCA = window.VCA || {};

window.VCA.oabDatalayer = (function ($) {

    if ($('.oab__wrapper').length <= 0) {
        return;
    }

    function datalayerPushPageLoad(data) {
        //push to datalayer step-1
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'baa-page-view',
            'hospital-name': data.hospitalName,
            'hospital-type': data.hospitalType,
            'hopital-AAU': data.hospitalIDValue,
            'is-logged-In': data.isLoggedIn
        });
    }


    function datalayerPushStepChange(data, currentPage, previousPageName) {

        let extraData =[
            'petSpecies',
            'apptTypeText',
            'appointmentReasonDisplayText',
            'assetName',
            'appointmentStartDate',
            'lastName',
        ]

        let stepInfo = {
            'event': 'baa-step-change',
            'current-page-name': currentPage,
            'previous-page-name': previousPageName,
            'Logged-in-status': data.isLoggedIn,
            'hospital-name': data.hospitalName,
            'hospital-type': data.hospitalType,
            'hopital-AAU': data.hospitalIDValue,
            'client-type': data.clientTypeText,
            'petSpecies': '',
            'apptTypeText': '',
            'appointmentReasonDisplayText': '',
            'assetName': '',
            'appointmentStartDate': '',
            'lastName': ''
        };

         extraData.forEach((dataPoint) => {
            if(data[dataPoint] !== '' && data[dataPoint] !== null) {
                stepInfo[dataPoint] = data[dataPoint];
            }
        }) 

        // console.log('stepInfo', stepInfo);
        //push to datalayer step-1
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(stepInfo);
    }


    function datalayerPushStepOne(data, currentPage, previousPageName) {
        //push to datalayer step-1
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'baa-step-1',
            'client-type': data.clientTypeText,
            'current-page-name': currentPage,
            'previous-page-name': previousPageName,
            'is-logged-In': data.isLoggedIn
        });
    }

    function datalayerPushStepTwo(data, currentPage, previousPageName) {
        //push step-2
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'baa-step-2',
            'pet-selected': data.petName,
            'current-page-name': currentPage,
            'previous-page-name': previousPageName,
            'is-logged-In': data.isLoggedIn
        });
    }

    function datalayerPushStepThree(data, currentPage, previousPageName) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'baa-step-3',
            'patient-type': data.petSpecies,
            'current-page-name': currentPage,
            'previous-page-name': previousPageName,
            'is-logged-In': data.isLoggedIn
        });
    }

    function datalayerPushStepFour(data, currentPage, previousPageName) {
        //push step-4
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'baa-step-4',
            'patient-type': data.petSpecies,
            'appointment-type': data.apptTypeText,
            'current-page-name': currentPage,
            'previous-page-name': previousPageName,
            'is-logged-In': data.isLoggedIn
        });
    }

    function datalayerPushStepFive(data, currentPage, previousPageName) {
              //push step-5
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                  'event': 'baa-step-5',
                  'patient-type': data.petSpecies,
                  'appointment-type': data.apptTypeText,
                  'reason': data.appointmentReasonDisplayText,
                  'current-page-name': currentPage,
                  'previous-page-name': previousPageName,
                  'is-logged-In': data.isLoggedIn
              });
    }

    function datalayerPushStepSix(data, currentPage, previousPageName) {
        //push step-6
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'baa-step-6',
            'patient-type': data.petSpecies,
            'appointment-type': data.apptTypeText,
            'reason': data.appointmentReasonDisplayText,
            'wellness-type': data.wellnessType,
            'current-page-name': currentPage,
            'previous-page-name': previousPageName,
            'is-logged-In': data.isLoggedIn
        });
    }

    function datalayerPushStepSeven(data, currentPage, previousPageName) {
        //push step-7
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'baa-step-7',
            'patient-type': data.petSpecies,
            'appointment-type': data.apptTypeText,
            'reason': data.appointmentReasonDisplayText,
            "doctor": data.assetName,
            "time-start": data.appointmentStartDate,
            'current-page-name': currentPage,
            'previous-page-name': previousPageName,
            'is-logged-In': data.isLoggedIn
        });
    }

    function datalayerPushBookAppt(data, currentPage, previousPageName) {
        window.dataLayer.push({
            'event': 'book-appointment',
            'offer-type': 'Book an Appointment',
            'patient-type': data.petSpecies,
            'appointment-type': data.apptTypeText,
            'reason': data.appointmentReasonDisplayText,
            "doctor": data.assetName,
            "time-start": data.appointmentStartDate,
            'customer-lastname': data.lastName,
            'current-page-name': currentPage,
            'previous-page-name': previousPageName,
            'is-logged-In': data.isLoggedIn
        });
    }

    function datalayerPushOfferSubmit(data, currentPage, previousPageName) {
        window.dataLayer.push({
            'event': 'offer-submission',
            'offer-type': 'Book an Appointment',
            'patient-type': data.petSpecies,
            'appointment-type': data.apptTypeText,
            'reason': data.appointmentReasonDisplayText,
            "doctor": data.assetName,
            "time-start": data.appointmentStartDate,
            'customer-lastname': data.lastName,
            'current-page-name': currentPage,
            'previous-page-name': previousPageName,
            'is-logged-In': data.isLoggedIn
        });
    }

    function datalayerAbandon(data, currentPage) {
        window.dataLayer.push({
            'event': 'baa-abandon',
            'current-page-name': currentPage,
            'is-logged-In': data.isLoggedIn
        });
    }


    return {
        datalayerPushPageLoad: datalayerPushPageLoad,
        datalayerPushStepOne: datalayerPushStepOne,
        datalayerPushStepTwo: datalayerPushStepTwo,
        datalayerPushStepThree: datalayerPushStepThree,
        datalayerPushStepFour: datalayerPushStepFour,
        datalayerPushStepFive: datalayerPushStepFive,
        datalayerPushStepSix: datalayerPushStepSix,
        datalayerPushStepSeven: datalayerPushStepSeven,
        datalayerPushBookAppt: datalayerPushBookAppt,
        datalayerPushOfferSubmit: datalayerPushOfferSubmit,
        datalayerAbandon: datalayerAbandon,
        datalayerPushStepChange: datalayerPushStepChange,
    };



})(jQuery);